<template>
  <Modal :title="title" name="SIGNED_TERM_INFO_MODAL">
    <template v-slot:body>
      <div v-if="termData">
        <div v-if="termData.signers">
          <v-card
            v-for="signer in termData.signers"
            :key="signer.key"
            elevation="0"
            class="pa-5 mb-3"
            outlined
          >
            <h6 class="text-uppercase grey--text">
              {{ $t('rentOut.termData.key') }}
            </h6>
            <v-chip class="body-2" v-if="signer.key">
              <small class="caption">
                {{ signer.key }}
              </small>
              <CopyToClipboard :value="signer.key" />
            </v-chip>

            <h6 class="text-uppercase grey--text mt-3">
              {{ $t('rentOut.termData.name') }}
            </h6>
            <span class="d-block body-2 ">
              {{ signer.name }}
            </span>
            <small class="grey--text caption">
              {{ signer.documentation }}
            </small>

            <h6 class="text-uppercase grey--text mt-3">
              {{ $t('rentOut.termData.signatureDate') }}
            </h6>
            <span
              v-if="signer.signature && signer.signature.signed_at"
              class="d-flex body-2 mb-0"
            >
              <v-icon color="green" left small>
                mdi-file-document-check-outline
              </v-icon>
              {{ date(signer.signature.signed_at) }}
            </span>

            <span v-else class="d-flex body-2 mb-0">
              <v-icon color="red lighten-1" left small>
                mdi-file-document-remove-outline
              </v-icon>
              {{ $t('rentOut.termData.termNotSignedYet')}}
            </span>
          </v-card>
        </div>
      </div>
    </template>
  </Modal>
</template>

<script>
import { catalogDate } from '@/util/catalog'

import CopyToClipboard from '@/components/app/CopyToClipboard'
import Modal from '@/components/app/Modal'

export default {
  name: 'ModalAppointmentSignedTerm',

  components: {
    Modal,
    CopyToClipboard,
  },

  props: {
    termData: {
      type: Object,
    }
  },

  methods: {
    date(dateTime) {
      if (!dateTime) return '---'
      return this.formatDate(dateTime)
    }
  },

  data() {
    return {
      title: this.$t('rentOut.termData.signers'),
      formatDate: catalogDate,
    }
  }
}
</script>
